// extracted by mini-css-extract-plugin
export default {"createExpense__form":"CreateExpense_createExpense__form__Lu0wM","createExpense":"CreateExpense_createExpense__0GVe7"};